import { animate } from "motion";

const clamp = (value, min, max) => Math.max(min, Math.min(value, max));

export default {
  init: () => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return;
    }

    const images = document.querySelectorAll(".parallax-image");

    if (!images.length) {
      return;
    }

    const handleIntersection = (entries) => {
      entries.forEach((entry) => {
        const image = entry.target;
        const container = image.closest(".parallax-image-container");
        if (!container) return;

        const scaleFactor = 1.1;

        const updateParallax = () => {
          const imageHeight = image.offsetHeight;
          const containerHeight = container.offsetHeight;
          const extraHeight = imageHeight * (scaleFactor - 1);
          const maxTranslate = extraHeight / 2;

          const rect = container.getBoundingClientRect();
          const windowHeight = window.innerHeight;
          const totalScroll = windowHeight + containerHeight;
          const relativeTop = rect.top;
          const scrollProgress = clamp((windowHeight - relativeTop) / totalScroll, 0, 1);

          const translateY = (scrollProgress - 0.5) * 2 * maxTranslate;

          animate(image, { y: translateY }, { duration: 0.5, easing: "ease-out" });
        };

        if (entry.isIntersecting) {
          const onScroll = () => {
            window.requestAnimationFrame(updateParallax);
          };

          const onResize = () => {
            window.requestAnimationFrame(updateParallax);
          };

          window.addEventListener("scroll", onScroll);
          window.addEventListener("resize", onResize);

          updateParallax();
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersection, {
      threshold: Array.from({ length: 101 }, (_, i) => i / 100),
    });

    images.forEach((image) => {
      observer.observe(image);
    });
  },
};
